import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f4d6b2fa"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=f4d6b2fa&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=f4d6b2fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports